import React from 'react';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import { Checkbox } from 'informed';
import { PvsCreative, PvsVertical, S3UploadParams } from 'models/interfaces';
import { FileUploadInput } from '@tpco/blueprint-react';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import { StackedText, StackedSelect, BooleanCheckbox } from '@tpco/blueprint-react';
import { printDate } from 'util/dateUtils';
import { ApolloConsumer } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import moment from 'moment';
import axios from 'axios';
import { validateCreativePlatform, validateCreativeName } from './PvsCampaignValidation';
import { toast } from 'react-toastify';
import {
  GET_CREATIVE_QUERY,
  GET_CREATIVE_UPLOAD_PARAMS_QUERY,
  DELETE_CREATIVE_IMAGE_MUTATION,
  SAVE_CREATIVE_MUTATION
} from 'containers/PvsCreativeContainer';
import util from 'util';

interface PvsCreativeEditProps {
  tgramsId: string;
  campaignId: string;
  companyName: string;
  verticalId: string;
  verticalDisplayName: string;
  verticalSnakeName: string;
  creativeId: string;
  bucketKey: string;
  name: string;
  clickUrl: string;
  isActive: boolean;
  platformId: number;
  imageExists: boolean;
  onEditFinished(): void;
}

interface PvsCreativeEditState {
  name: string;
  bucketKey: string;
  creativeId: string;
  isActive: boolean;
  fileExtension: string;
  hasUploadedImage: boolean;
}

class PvsCreativeEdit extends React.Component<PvsCreativeEditProps, PvsCreativeEditState> {
  private fileInput: any;

  constructor(props: PvsCreativeEditProps) {
    super(props);

    this.fileInput = React.createRef();

    const fileExtensionRegex = new RegExp(/[0-9a-z]+$/);
    const fileExtension = fileExtensionRegex.exec(this.props.bucketKey);

    console.log('fileExtension: ', fileExtension);

    this.state = {
      creativeId: this.props.creativeId,
      bucketKey: this.props.bucketKey,
      isActive: this.props.isActive,
      name: this.props.name,
      fileExtension: fileExtension ? fileExtension[0] : '',
      hasUploadedImage: this.props.imageExists
    };

    console.log('Constructing PvsCreativeEdit');
  }

  onWebImageChange = async (
    e: any,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
    values: any,
    client: ApolloClient<any>
  ) => {
    const {
      platformId,
      tgramsId,
      verticalDisplayName,
      verticalSnakeName,
      companyName,
      campaignId,
      verticalId
    } = this.props;

    const file = e.target.files[0];

    console.log('file: ', file);
    e.persist();

    console.log('fileInputRef: ', this.fileInput.current);

    // console.log(e.target.files[0]);

    let today = moment().format('YYYY-MM-DD');
    // const fileName = e.target.files[0].name;

    const plaform = platformId == 1 ? 'web' : 'mobile';

    // console.log(file.type);

    let extension = '';

    switch (file.type) {
      case 'image/gif':
        extension = 'gif';
        break;
      case 'image/jpg':
      case 'image/jpeg':
        extension = 'jpg';
        break;
      case 'image/png':
        extension = 'png';
        break;
      default:
        console.log('Invalid mime type!');
        toast.error(
          'File must be a GIF, JPEG, PNG, FLASH (SWF or FLV) that is not larger than 4MB.'
        );
        return;
    }

    const timestamp = moment().unix();

    const key = `${tgramsId}/${verticalSnakeName}/${today}/${plaform}_${timestamp}_${campaignId}.${extension}`;

    const { data } = await client.query({
      query: GET_CREATIVE_UPLOAD_PARAMS_QUERY,
      variables: { key }
    });

    const uploadUrl = data.uploadParams.url;

    // format response from gql
    const formatedParams: S3UploadParams = {
      key: data.uploadParams.fields.key,
      bucket: data.uploadParams.fields.bucket,
      'X-Amz-Algorithm': data.uploadParams.fields.X_Amz_Algorithm,
      'X-Amz-Credential': data.uploadParams.fields.X_Amz_Credential,
      'X-Amz-Date': data.uploadParams.fields.X_Amz_Date,
      Policy: data.uploadParams.fields.Policy,
      'X-Amz-Signature': data.uploadParams.fields.X_Amz_Signature
    };

    // it appears this isn't provided on localhost or w/ certain AccessKeys/Secrets
    // so only return this if it exists
    if (data.uploadParams.fields.X_Amz_Security_Token) {
      formatedParams['X-Amz-Security-Token'] = data.uploadParams.fields.X_Amz_Security_Token;
    }

    console.log('Formatted creative params: \n', util.inspect(formatedParams, false, 4));

    // persist upload form params to state
    this.setState({
      name: file.name,
      fileExtension: extension,
      bucketKey: formatedParams.key,
      hasUploadedImage: true
    });

    // build s3 post data
    let formData = new FormData();

    Object.entries(formatedParams).forEach(([key, value]) => {
      formData.append(key, value);
    });

    formData.append('file', file, file.name);

    // upload file to s3
    await axios.post(uploadUrl, formData, {
      headers: {
        'Content-Type': 'application/javascript'
      }
    });

    console.log('File uploaded successfully!');
    toast.success('File uploaded successfully!');

    await this.saveCreative(values, client, false, setFieldValue);
  };

  deleteFile = async (
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
    client: ApolloClient<any>
  ) => {
    const deleteResponse = await client.mutate({
      mutation: DELETE_CREATIVE_IMAGE_MUTATION,
      variables: { key: this.state.bucketKey, pvs_creative_id: this.props.creativeId },
      refetchQueries: [
        {
          query: GET_CREATIVE_QUERY,
          variables: { pvs_creative_id: this.props.creativeId }
        }
      ]
    });

    console.log('deleteResponse', deleteResponse);

    this.setState({ bucketKey: '', hasUploadedImage: false, fileExtension: '' });
    setFieldValue('name', '');

    toast.success('Image successfully removed!');
  };

  getSuggestedName = (values: any) => {
    const { tgramsId, verticalDisplayName, companyName, verticalId } = this.props;

    let formatSize = '[PLATFORM_SIZE]';

    switch (parseInt(values.platformId, 10)) {
      case CONSTANTS.DISPLAY_AD_PLATFORM.WEB:
        formatSize = '300x600';
        break;
      case CONSTANTS.DISPLAY_AD_PLATFORM.MOBILE:
        formatSize = '320x50';
        break;
      default:
        break;
    }

    return `${tgramsId} ${companyName} ${formatSize} ${verticalDisplayName} ${verticalId}.${
      this.state.fileExtension
    }`;
  };

  appendCampaignIdToUrl = (
    values: any,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    try {
      const url = new URL(values.clickUrl);
      const searchParams = new URLSearchParams(url.search);

      searchParams.set('wtc_id', this.props.campaignId);

      url.search = searchParams.toString();
      const newUrl = url.toString();

      console.log('newUrl: ', newUrl);

      setFieldValue('clickUrl', newUrl);
    } catch (error) {
      toast.error(
        'Failed to add campaign id to url. Check the format of the existing url and try again.'
      );
    }
  };

  setSuggestedName = (
    values: any,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    const creativeName = this.getSuggestedName(values);

    this.setState({ name: creativeName });

    setFieldValue('name', creativeName);
  };

  saveCreative = async (
    values: any,
    client: ApolloClient<any>,
    finishEdit: boolean,
    setFieldValue?: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    const { campaignId } = this.props;
    const { creativeId } = this.state;
    // // if setFieldValue was passed, it's because the file was just uploaded and we need to
    // if (typeof setFieldValue === 'function') {
    //   // set form's file name state
    //   setFieldValue('name', this.getSuggestedName(values));
    // }

    // make creative sql data
    const creative = {
      pvs_creative_id: creativeId,
      pvs_campaign_id: campaignId,
      ad_server_parent_id: '',
      name: values.name,
      platform_id: parseInt(values.platformId, 10),
      click_url: values.clickUrl,
      bucket_key: this.state.bucketKey,
      is_active: values.isActive,
      last_sync_date: null,
      is_dirty: true
    };

    // insert creative to db
    console.log('creative sql obj: ', creative);

    const saveResponse = await client.mutate({
      mutation: SAVE_CREATIVE_MUTATION,
      variables: { creative }
    });

    console.log('saveResponse', saveResponse);

    if (!creativeId) {
      this.setState({ creativeId: saveResponse.data.savePvsCreative });
    }

    toast.success('Creative successfully saved!');

    if (finishEdit) {
      this.props.onEditFinished();
    }
  };

  onFormValidate = (values: any) => {
    console.log('onFormValidate fired!');

    const errors: any = {};

    return errors;
  };

  renderImageUploader = () => {
    const platformSelectOptions: any = [
      {
        name: 'Web',
        value: '1'
      },
      {
        name: 'Mobile',
        value: '2'
      }
    ];

    const { platformId, clickUrl } = this.props;
    const { name, isActive, hasUploadedImage } = this.state;

    return (
      <ApolloConsumer>
        {client => (
          <Formik
            initialValues={{ platformId, clickUrl, name, isActive }}
            validate={this.onFormValidate}
            onSubmit={values => this.saveCreative(values, client, true)}
          >
            {({ values, setFieldValue, isSubmitting }) => (
              <Form>
                <StackedSelect
                  htmlId="edit-pvs-creative-platform"
                  fieldName="platformId"
                  labelText="Platform"
                  options={platformSelectOptions}
                  validate={validateCreativePlatform}
                  className="saturn-form-group saturn-col saturn-flex-column"
                />
                <div className="saturn-form-group pvs-creative__url-container">
                  <StackedText
                    htmlId="edit-pvs-creative-click-url"
                    fieldName="clickUrl"
                    labelText="Click Url"
                    className="saturn-form-group saturn-col saturn-flex-column pvs-creative__url"
                  />
                  <div className="pvs-creative__existing-actions">
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => this.appendCampaignIdToUrl(values, setFieldValue)}
                    >
                      Add campaign id
                    </button>
                  </div>
                </div>
                {hasUploadedImage ? (
                  <div className="saturn-form-group pvs-creative__existing-container">
                    <StackedText
                      htmlId="edit-pvs-creative-file-name"
                      fieldName="name"
                      labelText="File Name"
                      validate={validateCreativeName}
                      className="saturn-form-group saturn-col saturn-flex-column pvs-creative__file-name"
                    />
                    <div className="pvs-creative__existing-actions">
                      <button
                        type="button"
                        className="btn btn-warning pvs-creative__delete"
                        onClick={() => this.deleteFile(setFieldValue, client)}
                      >
                        Upload New
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary pvs-creative__auto-name"
                        onClick={() => this.setSuggestedName(values, setFieldValue)}
                      >
                        Use suggested name
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="pvs-creative__upload">
                    <FileUploadInput
                      ref={this.fileInput}
                      onChange={(e: any) => this.onWebImageChange(e, setFieldValue, values, client)}
                    />
                  </div>
                )}
                <BooleanCheckbox
                  htmlId="edit-pvs-creative-is-active"
                  fieldName="isActive"
                  labelText="Is Active"
                  className="pvs-creative__is-active"
                />
                <div className="pvs-creative__save-container">
                  <button
                    className="btn btn-primary pvs-creative__cancel"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Save
                  </button>
                  
                  <button
                    className="btn btn-secondary pvs-creative__cancel"
                    onClick={() => this.props.onEditFinished()}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </ApolloConsumer>
    );
  };

  render() {
    console.log('Rendering PvsCreativeEdit');
    return (
      <React.Fragment>
        <div className="pvs-creative__container">
          <h5 className="pvs-creative__title">Upload Image</h5>
          <div className="pvs-creative__edit">{this.renderImageUploader()}</div>
        </div>
      </React.Fragment>
    );
  }
}

export default PvsCreativeEdit;
